/* unplugin-vue-components disabled */import script from "./GlobalFixedHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./GlobalFixedHeader.vue?vue&type=script&setup=true&lang=ts"

import "./GlobalFixedHeader.vue?vue&type=style&index=0&id=3ccc9fc4&lang=css"
import "./GlobalFixedHeader.vue?vue&type=style&index=1&id=3ccc9fc4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ccc9fc4"]])

export default __exports__